import { render, staticRenderFns } from "./vizOtchetDevBezImot.vue?vue&type=template&id=e52d5b22"
import script from "./vizOtchetDevBezImot.vue?vue&type=script&lang=js"
export * from "./vizOtchetDevBezImot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports